import React from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

interface InvoiceData {
  customerId: string;
  description: string;
  invoiceDueAt: string;
  additionalInformation?: string;
  status: string;
  inventories: {
    id: string;
    rate: number;
    quantity: number;
  }[];
  tax:number;
  discount:number;
}

interface DraftConfirmationPromptProps {
  onSaveDraft: (event: any) => void;
  onClose?: () => void;
  showSidebar: boolean;
}
const DraftConfirmationPrompt: React.FC<DraftConfirmationPromptProps> = ({ onSaveDraft, onClose, showSidebar }) => {
  const navigate = useNavigate();

  const handleSaveDraft = async (e: React.MouseEvent<HTMLButtonElement>) => {
    onSaveDraft(e);
    onClose && onClose();
  };

  const handleKeepEditing = () => {
    onClose && onClose();
  };

  return (
    <>
      <div className="h-screen">
        <div className="  flex justify-center mt-[13px] ">
          <h1>
            You are about to save this invoice as a draft? You can come back to edit and create the invoice at anytime.
          </h1>
        </div>
        <div role="form" onSubmit={(e) => e.preventDefault()}>
          <div className="flex ml-[10px] pt-[79px] pb-[40px]">
            <button
              className="w-[239px] rounded-[4px] h-[55px] bg-[#044E97] text-white font-semibold"
              onClick={handleSaveDraft}
            >
              Yes, save as draft
            </button>
          </div>
          <div className="flex ml-[10px] pb-[60px]">
            <button
              className="w-[239px] rounded-[4px] h-[55px] bg-[#F6F6F6] text-[#044E97] font-semibold"
              onClick={handleKeepEditing}
            >
             Continue Editing
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export { DraftConfirmationPrompt };
